module.exports = __webpack_public_path__ + "static/media/2-4-1_Spot_UV_Glossy_03.81cefd05.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/printing-information/Printing-Techniques/2-4-1_Spot_UV_Glossy_03.jpg
// module id = 1726
// module chunks = 0